import React from 'react';
import { Link } from 'react-router-dom';

const Cta = () => {
  return (
    <section className="py-[100px] bg-gradient-to-r from-primary to-secondary text-white" id="cta">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Transform Your Dealership's Performance?
          </h2>
          <p className="text-lg text-white/90 mb-[30px] max-w-3xl mx-auto">
            Join thousands of automotive professionals who trust LiveFunnel to grow their business
            and deliver exceptional customer experiences.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-5">
            <Link
              to="/signup"
              className="inline-block px-[30px] py-[15px] bg-white text-primary font-semibold rounded-lg hover:bg-gray-100 transition-colors duration-300"
            >
              Start Your Free Trial
            </Link>
            <Link
              to="/demo"
              className="inline-block px-[30px] py-[15px] border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-primary transition-colors duration-300"
            >
              Schedule a Demo
            </Link>
          </div>
          <p className="mt-6 text-white/70 text-sm">
            No credit card required • 14-day free trial • Cancel anytime
          </p>
        </div>
      </div>
    </section>
  );
};

export default Cta;
